import styles from '../PayNumberModal/PayNumber.module.css';
import { useModal } from '../../hooks/modalContext';
import clsx from 'clsx';
import check from '../../../assets/helpers/modals/rewards/check.png';
import { useTheme } from '../../hooks/ThemeContext';
import { usePoints } from '../../hooks/pointsContext';

const SuccessGiftCard = () => {
  const { modalState } = useModal();
  const { refreshPoints } = usePoints();

  const { theme } = useTheme();
  const { isChangeRequest } = modalState || {};
  const isDark = theme === 'dark' && !isChangeRequest;
  return (
    <main className={clsx(styles.main, isDark && styles.mainDark)}>
      <section className={styles.section}>
        <div className={styles.message}>
          <img src={check} alt='check' className={styles.check} />
          <h2 className={`${styles.heading} ${isDark && styles.headingDark}`}>Gift card sent</h2>
          <p className={styles.messageContent}>
            Your gift card has been successfully processed. To redeem it, please check your
            registered email for the details.
          </p>

          <button
            className={`${styles.btn} w-full mt-[10px]`}
            onClick={async () => {
              await refreshPoints();
            }}
          >
            Continue
          </button>
        </div>
      </section>
    </main>
  );
};
export default SuccessGiftCard;
